<script setup>

import backgroundImage from "@/assets/images/footer_image.png";
import CustomButton from "@/components/Button/Button.vue";
import {useRouter} from "vue-router";
import {useRouteHelpers} from "@/composables/useRouteHelp.js";
import {useBlogStore} from "@/stores/blogStore.js";
import {useAboutStore} from "@/stores/aboutStore.js";
import {onMounted} from "vue";
import PhoneItem from "@/components/PhoneItem/PhoneItem.vue";

const router = useRouter();
const blogStore = useBlogStore();
const aboutStore = useAboutStore();


const { isYachtPage, isBlogPage, isBlogArticlePage, isHomePage, isDestinationsPage, isDestinationPage, isAboutPage } = useRouteHelpers();

onMounted(() => {
  aboutStore.getContactInfo();
});
</script>

<template>
  <div :class="isHomePage || isDestinationsPage || isDestinationPage || isAboutPage ? 'pt-0' : 'pt-24'">

    <div v-show="!isYachtPage && !isBlogPage && !isBlogArticlePage" class="relative h-[65vh] max-h-[650px] flex justify-center items-center text-white overflow-hidden">
      <div
          class="absolute inset-0 bg-cover bg-center sm:bg-fixed opacity-20 z-0"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
      >

      </div>

      <div class="relative z-10 flex flex-col gap-17 items-center">
        <div class="grid gap-7.5 text-center">
          <span class="responsive-title-1 text-primary-darkBlue font-thin px-2">Ready for Yachting?</span>
          <span class="text-bw-midGrey font-bold responsive-body-xlarge max-w-xl mx-auto px-4">Ask one of our charter broker(s) to help you find the perfect yacht of your choice</span>
        </div>
        <CustomButton
            type="red"
            size="medium"
            class="py-5 px-5"
            @click="router.push('/inquiry')"
        >
        MAKE AN INQUIRY
        </CustomButton>
      </div>
    </div>

    <footer class="bg-background-beige">
      <div class="container pt-16 pb-8 flex flex-col ">
        <div class="flex flex-col sm:flex-row sm:gap-36">
          <div class="flex flex-col justify-between mb-15">
            <div>
              <div class="gap-10">
                <div class="logo flex items-center mb-10">
                  <img
                      src="@/assets/logo_luxury_yachts_red.png"
                      alt="Cosmos Yachting"
                      class="h-9 sm:h-10 w-auto max-w-full object-contain"
                  />
                </div>
                <div class="flex flex-col gap-6">
                  <div class="flex items-start gap-2">
                    <img src="@/assets/icons/phone.png" alt="Phone" class="h-6 w-6 flex-shrink-0 mt-1"/>
                    <div class="flex flex-col gap-2 responsive-body-medium text-primary-darkBlue">
                      <div v-for="contact in aboutStore.contactInfo">
                        <PhoneItem :contact="contact"/>
                      </div>
                    </div>
                  </div>

                  <div class="flex items-center gap-2">
                    <img src="@/assets/icons/email.png" alt="Email" class="h-6 min-w-6"/>
                    <div class="flex items-center gap-2 text-primary-darkBlue text-no-wrap responsive-body-medium">
                      <a href="mailto:info@cosmosluxuryyachts.com" class="hover:underline">info@cosmosluxuryyachts.com</a>
                    </div>
                  </div>

                  <div class="flex items-center gap-2">
                    <img src="@/assets/icons/address.svg" alt="Address" class="h-6 min-w-6"/>
                    <div class="flex items-center gap-2 text-primary-darkBlue responsive-body-medium">
                      7 Eleftherias Avenue, Alimos 17455, Athens, Greece
                    </div>
                  </div>

                  <div class="flex items-center gap-2.5 pl-10 text-primary-darkBlue">
                    <span class="responsive-body-small">Follow us</span>
                    <a href="https://www.facebook.com/cosmosyachtingHQ/" target="_blank">
                      <img src="@/assets/social/facebook.png" alt="Facebook" class="h-6 min-w-6"/>
                    </a>
                    <a href="https://www.instagram.com/cosmosyachting/" target="_blank">
                      <img src="@/assets/social/instagram.png" alt="Instagram" class="h-6 min-w-6"/>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="max-w-screen-xl responsive-body-xlarge text-primary-darkBlue font-semibold grid grid-cols-3 gap-8 md:gap-36 links sm:pt-17 text-center">
            <div class="flex flex-col gap-2">
              <RouterLink class="mb-4 hover:text-primary-violet"
                          :to="`/yachts`">
                Yachts
              </RouterLink>
              <RouterLink class="mb-4 hover:text-primary-violet"
                          :to="`/guide`">
                Charter
              </RouterLink>
              <RouterLink class="mb-4 hover:text-primary-violet"
                          :to="`/inquiry`">
                Inquiry
              </RouterLink>
            </div>
            <div class="flex flex-col gap-2">
              <RouterLink class="mb-4 hover:text-primary-violet"
                          :to="`/destinations`">
                Destinations
              </RouterLink>
              <RouterLink class="mb-4 hover:text-primary-violet text-nowrap"
                          :to="`/aboutUs`">
                About us
              </RouterLink>
              <RouterLink class="mb-4 hover:text-primary-violet"
                          :to="`/magazine`">
                Magazine
              </RouterLink>
            </div>
            <RouterLink class="mb-4 hover:text-primary-violet"
                        :to="`/imprint`">
              Imprint
            </RouterLink>
          </div>
        </div>
      </div>
    </footer>
    <div class="bg-white py-4 responsive-body-xsmall flex flex-row gap-8">
      <div class="container flex text-bw-midGrey gap-4">
        <div>Copyright © 1987 - 2025 <span class="text-nowrap">Cosmos Luxury Yachts</span></div>
        <div class="flex gap-2 text-center">
          <div>Terms & Conditions</div>
          <div class="border-l"></div>
          <div>Privacy policy</div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.backgroundImage::before {
  content: "";
  background-image: url('@/assets/images/footer_image.png');
  background-size: cover;
  background-position: center;
  opacity: 0.18;
  z-index: 0;
  position: absolute;
  inset: 0;
}


@media (max-width: 768px) {
  .backgroundImage {
    max-height: 474px;
    background-position: center;
  }
}

</style>
